;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.creditnote.show')
    .controller('CreditNoteShowToolbarController', CreditNoteShowToolbarController)

  CreditNoteShowToolbarController.$inject = [
    // Angular
    '$scope', '$state', '$uibModal',
    // manager
    'CreditNoteManager',
    // Services
    'UtilService', 'SnackService', 'DisplayService', 'PreferencesService',

    // Resolve
    'element', 'template', 'urls'

  ]

  function CreditNoteShowToolbarController (
    // Angular
    $scope, $state, $uibModal,
    // manager
    CreditNoteManager,
    // Services
    UtilService, SnackService, DisplayService, PreferencesService,

    // Resolve
    element, template, urls

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        creditNote: element,
        template: template,
        title: element.title,
        status: element.status,
        number: getInvoiceNumber(),
        creditNoteManager: CreditNoteManager,
        // Methods
        archiveCreditNote: archiveCreditNote,
        init: init,
        restoreCreditNote: restoreCreditNote,
        extranet: extranet,
        deleteCreditNote: deleteCreditNote
      })

      init()
    }

    $scope.$watch(function () {
      return template
    }, function () {
      self.template = template
      self.number = getInvoiceNumber()
    })

    function init () {
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore
      })
    }

    function getInvoiceNumber () {
      if (element.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(element, 'creditnote', element.numberFormat)
    }

    function archiveCreditNote () {
      var content = "Vous êtes sur le point d'archiver cet avoir.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?"
      DisplayService.displayConfirm('Archiver', content).then(function () {
        element.archive().then(function () {
          SnackService.snack({
            text: 'Avoir archivé !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function restoreCreditNote () {
      var content = 'Vous êtes sur le point de restaurer cet avoir.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        element.restore().then(function () {
          SnackService.snack({
            text: 'Avoir restauré !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function extranet () {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return 'creditnote' }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        let url = `${urls.extranet}/creditnotes/${element._id}`
        if (template !== false) {
          url += '/' + template._id
        }
        window.open(url, '_blank')
      })
    }

    function deleteCreditNote () {
      DisplayService.confirmDeletion().then(function () {
        self.creditNoteManager.delete(element).then(() => {
          SnackService.snack({
            text: 'Avoir supprimé !',
            delay: 5000
          })
          $state.go('creditnote.list')
        })
      })
    }
  }
})(window.angular, window._)
